export default {
  // Navigation
  nav_home: "Trang chủ",
  nav_products: "Sản phẩm",
  nav_about: "Giới thiệu",
  nav_support: "Hỗ trợ",
  nav_contact: "Liên hệ",

  // Hero Section
  hero_title: "Nhạc cụ Taishan",
  hero_subtitle: "Nhạc cụ cao cấp Made in China",
  hero_description: "Chuyên sản xuất nhạc cụ đồng chất lượng cao từ năm 1987",
  hero_cta: "Khám phá sản phẩm",

  // Products Section
  products_title: "Sản phẩm của chúng tôi",
  products_subtitle: "Nhạc cụ đồng chuyên nghiệp, chế tác tinh xảo",
  product_trumpet: "Dòng kèn Trumpet",
  product_trumpet_desc: "Nhạc cụ đồng chuyên nghiệp với âm thanh sáng, đầy đặn, phù hợp mọi dịp biểu diễn",
  product_trombone: "Dòng kèn Trombone",
  product_trombone_desc: "Trượt mượt mà, âm vực rộng, được các dàn nhạc chuyên nghiệp ưa chuộng",
  product_saxophone: "Dòng kèn Saxophone",
  product_saxophone_desc: "Âm thanh tròn trịa, êm dịu, hoàn hảo cho nhạc jazz và cổ điển",
  product_horn: "Dòng kèn French Horn",
  product_horn_desc: "Âm thanh mềm mại, ấm áp, không thể thiếu trong dàn nhạc giao hưởng",
  product_clarinet: "Dòng kèn Clarinet",
  product_clarinet_desc: "Nhạc cụ gỗ cổ điển với âm thanh trong trẻo, quyến rũ",
  product_flute: "Dòng sáo Flute",
  product_flute_desc: "Âm thanh trong trẻo, du dương, lý tưởng cho độc t주 và hòa tấu",
  view_details: "Xem chi tiết",

  // Product Catalog
  catalog_title: "Tải Catalog Sản Phẩm",
  catalog_description: "Tải catalog đầy đủ của Taishan Instruments để biết thông số kỹ thuật chi tiết",
  catalog_download: "Tải Catalog",

  // About Section
  about_title: "Giới thiệu",
  about_subtitle: "Hơn 30 năm kế thừa nghề thủ công",
  about_heading: "Về Nhạc cụ Taishan",
  about_p1: "Công ty TNHH Sản xuất Nhạc cụ Đồng Taishan Sơn Đông được thành lập năm 1987, là nhà sản xuất nhạc cụ đồng chuyên nghiệp hàng đầu Trung Quốc. Tọa lạc tại tỉnh Sơn Đông, công ty sở hữu cơ sở sản xuất hiện đại và đội ngũ R&D chuyên nghiệp.",
  about_p2: "Năm 2004, sản phẩm của công ty đã được Trung tâm Giám sát và Kiểm tra Chất lượng Nhạc cụ của Bộ Văn hóa kiểm tra và đều đạt tiêu chuẩn quốc gia. Năm 2006, công ty đã trở thành đơn vị đánh giá trực tiếp và được trao danh hiệu 'Doanh nghiệp mạnh trong ngành Nhạc cụ Trung Quốc'.",
  about_p3: "Công ty đã đạt chứng nhận hệ thống chất lượng ISO9001 và chứng nhận hệ thống môi trường ISO14001. Sản phẩm được xuất khẩu đến nhiều quốc gia và khu vực trên thế giới, được người yêu âm nhạc và nghệ sĩ chuyên nghiệp tin tưởng.",
  about_year: "Thành lập",
  about_series: "Dòng sản phẩm",

  // Timeline
  timeline_title: "Hành trình của chúng tôi",
  timeline_1987: "Công ty thành lập, tập trung sản xuất nhạc cụ đồng",
  timeline_2001: "Trở thành thành viên Triển lãm Nhạc cụ Quốc tế Trung Quốc",
  timeline_2004: "Sản phẩm đạt kiểm tra của Trung tâm Giám sát Chất lượng Nhạc cụ Bộ Văn hóa, đạt tiêu chuẩn quốc gia",
  timeline_2006: "Được trao danh hiệu 'Doanh nghiệp mạnh trong ngành Nhạc cụ Trung Quốc'",
  timeline_2013: "Nhạc cụ đồng Taishan trở thành thương hiệu Trung Quốc cạnh tranh với các thương hiệu quốc tế nổi tiếng",
  timeline_2019: "Được Sở Khoa học và Công nghệ tỉnh Sơn Đông trao danh hiệu doanh nghiệp vừa và nhỏ 'Chuyên môn hóa, Tinh tế, Đặc sắc và Sáng tạo'",

  // Support Section
  support_title: "Hỗ trợ & Dịch vụ",
  support_subtitle: "Hệ thống dịch vụ sau bán hàng chuyên nghiệp",
  support_quality: "Đảm bảo chất lượng",
  support_quality_desc: "Chứng nhận ISO9001, mọi sản phẩm đều trải qua kiểm tra nghiêm ngặt",
  support_service: "Dịch vụ sau bán hàng",
  support_service_desc: "Đội ngũ sau bán hàng chuyên nghiệp cung cấp bảo trì và tư vấn",
  support_maintenance: "Sửa chữa & Bảo trì",
  support_maintenance_desc: "Dịch vụ sửa chữa và bảo trì nhạc cụ chuyên nghiệp",
  support_guide: "Hướng dẫn sử dụng",
  support_guide_desc: "Hướng dẫn sử dụng chi tiết và hướng dẫn bảo trì",

  // FAQ
  faq_title: "Câu hỏi thường gặp",
  faq_q1: "Làm thế nào để chọn nhạc cụ đồng phù hợp?",
  faq_a1: "Chúng tôi khuyên bạn nên chọn dựa trên trình độ chơi, phong cách âm nhạc và ngân sách của bạn. Người mới bắt đầu có thể chọn sản phẩm cấp độ nhập môn, trong khi nghệ sĩ chuyên nghiệp có thể chọn dòng cao cấp. Đội ngũ dịch vụ khách hàng của chúng tôi có thể cung cấp tư vấn chuyên nghiệp.",
  faq_q2: "Thời gian bảo hành là bao lâu?",
  faq_a2: "Sản phẩm của chúng tôi có bảo hành một năm. Các vấn đề chất lượng trong điều kiện sử dụng bình thường sẽ được sửa chữa hoặc thay thế miễn phí.",
  faq_q3: "Làm thế nào để bảo trì nhạc cụ đồng?",
  faq_a3: "Chúng tôi khuyên bạn nên làm sạch bên trong nhạc cụ sau mỗi lần sử dụng, thường xuyên tra dầu van và ống trượt, tránh va chạm và nhiệt độ cực đoan. Vui lòng tham khảo hướng dẫn sản phẩm để biết hướng dẫn bảo trì chi tiết.",
  faq_q4: "Có cung cấp vận chuyển quốc tế không?",
  faq_a4: "Có, sản phẩm của chúng tôi được bán đến nhiều quốc gia và khu vực trên thế giới. Vui lòng liên hệ đội ngũ bán hàng của chúng tôi để biết phương thức vận chuyển cụ thể và chi phí.",

  // Contact Section
  contact_title: "Liên hệ",
  contact_subtitle: "Chúng tôi mong được nghe từ bạn",
  contact_info: "Thông tin liên hệ",
  contact_address: "Địa chỉ",
  contact_address_value: "Tỉnh Sơn Đông, Trung Quốc",
  contact_phone: "Điện thoại",
  contact_phone_value: "+65 91791835",
  contact_whatsapp: "WhatsApp",
  contact_whatsapp_value: "+65 91791835",
  contact_whatsapp_button: "Trò chuyện trên WhatsApp",
  contact_email: "Email",
  contact_email_value: "Vui lòng để lại tin nhắn qua biểu mẫu, chúng tôi sẽ trả lời sớm nhất có thể",
  contact_hours: "Giờ làm việc",
  contact_hours_value: "Thứ Hai đến Thứ Sáu 9:00-18:00",
  contact_form_title: "Để lại tin nhắn",
  contact_form_name: "Tên",
  contact_form_email: "Email",
  contact_form_phone: "Điện thoại",
  contact_form_message: "Tin nhắn",
  contact_form_submit: "Gửi",
  contact_form_name_placeholder: "Vui lòng nhập tên của bạn",
  contact_form_email_placeholder: "Vui lòng nhập email của bạn",
  contact_form_phone_placeholder: "Vui lòng nhập số điện thoại của bạn",
  contact_form_message_placeholder: "Vui lòng nhập tin nhắn của bạn (tối đa 500 ký tự)",
  contact_form_required: "Bắt buộc",
  contact_form_success: "Gửi thành công! Chúng tôi sẽ liên hệ với bạn sớm.",
  contact_form_error: "Gửi thất bại, vui lòng thử lại sau.",
  contact_form_validate_required: "Vui lòng điền tất cả các trường bắt buộc",
  contact_form_validate_email: "Vui lòng nhập địa chỉ email hợp lệ",
  contact_form_validate_message: "Tin nhắn không được vượt quá 500 ký tự",

  // Footer
  footer_description: "Chuyên sản xuất nhạc cụ đồng chất lượng cao, cung cấp sản phẩm xuất sắc cho người yêu âm nhạc và nghệ sĩ chuyên nghiệp.",
  footer_quick_links: "Liên kết nhanh",
  footer_contact_us: "Liên hệ chúng tôi",
  footer_address: "Địa chỉ: Tỉnh Sơn Đông, Trung Quốc",
  footer_hours: "Giờ làm việc: Thứ Hai đến Thứ Sáu 9:00-18:00",
  footer_copyright: "Bản quyền thuộc về.",
  footer_powered: "Được hỗ trợ bởi Readdy"
};
